import { useTranslation } from "react-i18next";

import { Window } from "components/window/window";
import { type BaseWindowProps } from "contexts/windows";
import { OctreeDebugContent } from "features/octreeDebug/octreeDebugContent";
import { useResetOctreeDebugOnUnmount } from "features/octreeDebug/useResetOctreeDebugOnUnmount";

export function OctreeDebugWindow({ onClose, position = "center", ...props }: BaseWindowProps) {
    const { t } = useTranslation();
    useResetOctreeDebugOnUnmount();

    return (
        <Window
            position={position}
            size={{ width: 400, height: 500 }}
            title={t("octreeDebug")}
            onClose={onClose}
            secondaryBgColor
            data-testid="octree-debug-window"
            {...props}
        >
            <OctreeDebugContent />
        </Window>
    );
}
